module.exports = __webpack_public_path__ + "b0ceb0c78fde53851485a7351cc9ec02.png";